// H5 埋点上报组件
import ObusReport from '@cpc/lib-obus-report';
import DcsReport from '@cpc/lib-dcs-report';
import { weatherBizTracReport } from '@js/native';
import { getQuery } from '@js/utils';

import {
  buuid,
  _docId,
  iflowScene,
  stat_id,
  enterId,
  getDetailPageMode,
} from './constants';
import { BrowserBridgeHandler } from '../js/browserBridgeHandler';
import { commonSdkStyleMap } from '../../config/const';

const logTagMap = {
  weather: '70001',
  hotlist: '71001',
  todaynews: '72001',
  topic: '73001',
};

// 锁屏场景
const magazineLogTagMap = {
  list_weather: '70001',
  // activity_screen: '77000', // 锁屏活动页
  // detailpage_screen: '77001', // 锁屏详情页
  // topic_screen: '77002', // 锁屏专题页
  // hotlist_screen: '77003', // 锁屏热榜页
};
let module = '';
module =
  iflowScene && magazineLogTagMap[iflowScene]
    ? magazineLogTagMap[iflowScene]
    : iflowScene;

let _start, _end;
const url = location.href;

const { title, source, keywords, pageType } = window.pageData.DOCINFO || {};

const baseData = {
  title,
  url,
  stat_id,
  type: pageType == 'document' ? 'article' : pageType,
  sourceMedia: source,
  source: 'OPPO',
  module,
  fromId: getQuery('__fromId__'),
  channelName: getChannelName(getQuery('__fromId__')),
  iflowSource: 'oppo',
  buuid: buuid ? buuid : '',
  enterId,
};

const dcsReport = new DcsReport({
  appId: window.pageData?.isCommonSdk ? '121600' : '105301',
  logTag: '10012',
  defaultHead: {
    appId: window.pageData?.isCommonSdk ? '121600' : '105301',
    logTag: '10012',
    imei: buuid,
  },
  commonBody: {},
});

var obusReport = {
  send: () => {},
};
// 判断是否已经实例化过 避免重复实例化报错
if (window.obusReport) {
  obusReport = window.obusReport;
} else {
  obusReport = new ObusReport({
    appId: '130900',
    appKey: '1360',
    logTag: '10012',
    env: 'prod', // pre 测试 prod 正式
    commonBody: {
      imei: buuid,
      old_app_id: window.pageData?.isCommonSdk ? '121600' : '105301',
    },
  });
  window.obusReport = obusReport;
}

// 获取上报到dcs 所需head数据,没有duid和imei时,使用buuid 兜底
const getReportHeadInfo = async (browserInfo) => {
  browserInfo = browserInfo || (await BrowserBridgeHandler.getBrowserInfo());
  return {
    imei: browserInfo.imei || (!browserInfo.duid && buuid) || '',
    duid: browserInfo.duid || '',
    ouid: browserInfo.ouid || '',
  };
};

// 根据 fromId 获取对应的 频道名称channelName
export function getChannelName(fromId) {
  let channelName = '';
  switch (fromId) {
    case '5aSp5rCU':
    case '6ZSB5o6o':
    case '5o6o6I2Q':
    case 'normal':
      channelName = '推荐';
      break;
    case '6L+Q5Yqo':
    case '6L Q5Yqo':
      channelName = '运动';
      break;
    case '5rSX6L2m':
      channelName = '洗车';
      break;
    case '5o6n5rK5':
      channelName = '化妆';
      break;
    case '6Ziy5oqk':
      channelName = '防晒';
      break;
    case '5peF5ri4':
      channelName = '旅行';
      break;
    case '55+t6KKW':
    case '55 t6KKW':
      channelName = '穿衣';
      break;
    case '5Lqk6YCa':
      channelName = '交通';
      break;
    case '5oSf5YaS':
      channelName = '感冒';
      break;
  }
  return channelName;
}

async function onClickRelatedNews(data) {
  let {
    openSource,
    sourceMedia,
    pos,
    DocID,
    docid,
    docId,
    url,
    title,
    source,
    impid,
    stat_id,
    push_source,
    category,
    source_name,
    topCategory,
    secondCategory,
    type,
    mediaName,
    mediaId,
    detailPageMode,
    bizTraceId,
    bizTraceTransparent,
  } = data[0];
  const browserInfo = await BrowserBridgeHandler.getBrowserInfo();

  const d = Object.assign({}, baseData, {
    openSource,
    sourceMedia,
    position: pos,
    docId: DocID || docid || docId,
    sourceDocId: _docId,
    topCategory,
    secondCategory,
    mediaName,
    mediaId,
    impid,
    stat_id,
    category,
    url,
    title,
    source,
    push_source,
    source_name,
    type,
    bizTraceId,
    bizTraceTransparent,
    detailPageMode,
  });
  // 通用信息流详情页新增埋点字段
  if (window.pageData?.isCommonSdk) {
    d.module = 21034;
    d.uuid = browserInfo.uuid || '';
    d.appSession = browserInfo.appSession || '';
    d.classifyByAge = browserInfo.classifyByAge || '';
    d.adaptBrand = browserInfo.adaptBrand || '';

    if (window.IflowWebStat?.statWebEvent) {
      console.log('statWebEvent stat', d);
      window.IflowWebStat?.statWebEvent?.(
        '20083046',
        '21034',
        JSON.stringify(d),
      );
      return;
    }
  }
  console.log('stat in onClickRelatedNews', d.position);
  dcsReport.send(
    [{ logMap: JSON.stringify(d), eventID: '20083046', module }],
    await getReportHeadInfo(),
    true,
  );
  obusReport.send(
    [{ logMap: JSON.stringify(d), eventID: '20083046', module }],
    await getReportHeadInfo(),
    true,
  );
}
async function onRelatedNewsExposured(data) {
  let {
    openSource,
    sourceMedia,
    pos,
    DocID,
    docid,
    docId,
    url,
    title,
    source,
    impid,
    stat_id,
    push_source,
    category,
    source_name,
    topCategory,
    secondCategory,
    type,
    mediaName,
    mediaId,
    detailPageMode,
    bizTraceId,
    bizTraceTransparent,
  } = data[0];
  const browserInfo = await BrowserBridgeHandler.getBrowserInfo();
  const d = Object.assign({}, baseData, {
    openSource,
    sourceMedia,
    position: pos,
    docId: DocID || docid || docId,
    sourceDocId: _docId,
    topCategory,
    secondCategory,
    mediaName,
    mediaId,
    impid,
    stat_id,
    category,
    source,
    push_source,
    source_name,
    url,
    title,
    type,
    bizTraceId,
    bizTraceTransparent,
    detailPageMode,
  });

  // 通用信息流详情页新增埋点字段
  if (window.pageData?.isCommonSdk) {
    d.module = 21034;
    d.uuid = browserInfo.uuid || '';
    d.appSession = browserInfo.appSession || '';
    d.classifyByAge = browserInfo.classifyByAge || '';
    d.adaptBrand = browserInfo.adaptBrand || '';

    if (window.IflowWebStat?.statWebEvent) {
      console.log('statWebEvent stat', d);

      window.IflowWebStat?.statWebEvent?.(
        '20083168',
        '21034',
        JSON.stringify(d),
      );
      return;
    }
  }
  console.log('stat in onRelatedNewsExposured', d);
  dcsReport.send(
    [{ logMap: JSON.stringify(d), eventID: '20083168', module }],
    await getReportHeadInfo(),
    true,
  );
  obusReport.send(
    [{ logMap: JSON.stringify(d), eventID: '20083168', module }],
    await getReportHeadInfo(),
    true,
  );
}

async function statVideoPlayingDuration(data) {
  const detailPageMode = getDetailPageMode();
  const d = Object.assign({}, baseData, data, {
    category: keywords.toString(),
    docId: _docId,
    detailPageMode,
  });
  console.log('statVideoPlayingDuration', d);
  dcsReport.send(
    [
      {
        logMap: JSON.stringify(d),
        eventID: '20083207',
        module,
      },
    ],
    await getReportHeadInfo(),
    true,
  );
  obusReport.send(
    [
      {
        logMap: JSON.stringify(d),
        eventID: '20083207',
        module,
      },
    ],
    await getReportHeadInfo(),
    true,
  );
}

async function countPageViewingTime() {
  _end = new Date().getTime();
  const viewTime = (_end - _start) / 1000;
  console.log('duration:', viewTime);
  const detailPageMode = getDetailPageMode();

  // 上报天气信息流归因参数
  let bizTraceInfo = weatherBizTracReport();
  console.log('bizTraceInfo', bizTraceInfo);

  const data = Object.assign({}, baseData, {
    openSource: '',
    viewTime,
    readingProgress: localStorage.getItem('readingProgress') || 0,
    docId: _docId,
    highlightSearch: Array.isArray(window.highLightObj.highlightSearch)
      ? window.highLightObj.highlightSearch.join('|')
      : '',
    highlightSearchType: Array.isArray(window.highLightObj.highlightSearchType)
      ? window.highLightObj.highlightSearchType.join('|')
      : '',
    ...bizTraceInfo,
    detailPageMode,
  });

  if (window.BrowserNormal?.getAppHost?.() === 3) {
    module = '90002';
  } else if (window.BrowserNormal?.getAppHost?.() === 1) {
    module = '91002';
  }
  dcsReport.send(
    [
      {
        logMap: JSON.stringify(data),
        eventID: '20083047',
        module,
      },
    ],
    await getReportHeadInfo(),
    true,
  );
  _start = _end;
  obusReport.send(
    [
      {
        logMap: JSON.stringify(data),
        eventID: '20083047',
        module,
      },
    ],
    await getReportHeadInfo(),
    true,
  );
}

function handleVisibilityChange() {
  console.log('handleVisibilityChange', document.visibilityState);
  if (document.visibilityState == 'visible') {
    _start = Date.now();
  } else {
    countPageViewingTime();
  }
}

function statPageLife() {
  _start = Date.now();
  if (typeof document.visibilityState != 'undefined') {
    document.addEventListener('visibilitychange', handleVisibilityChange);
  } else if (typeof document.webkitVisibilityState != 'undefined') {
    document.addEventListener('webkitvisibilitychange', handleVisibilityChange);
  }
}

// 高量词点击埋点事件
export function wordsReport(data) {
  // 截止到20231219 该埋点未录入obus
  dcsReport.send(
    [{ logMap: JSON.stringify(data), eventID: '20084486', module }],
    {},
    true,
  );
  obusReport.send(
    [{ logMap: JSON.stringify(data), eventID: '20084486', module }],
    {},
    true,
  );
}

// 高量词新埋点事件
export async function newWordsReport(data, eventID) {
  const browserInfo = await BrowserBridgeHandler.getBrowserInfo();
  dcsReport.send(
    [
      {
        logMap: JSON.stringify(data),
        eventID: eventID,
        module: '12009',
        appId: '2007',
        logTag: '10006',
        imei: browserInfo.imei || '',
        duid: browserInfo.duid || '',
      },
    ],
    {
      appId: '2007',
      logTag: '10006',
      eventID: eventID,
      module: '12009',
      imei: browserInfo.imei || '',
      duid: browserInfo.duid || '',
      buuid: buuid,
      ...(await getReportHeadInfo(browserInfo)),
    },
    true,
  );
  obusReport.send(
    [
      {
        logMap: JSON.stringify(data),
        eventID: eventID,
        module: '12009',
        appId: '130900',
        logTag: '10006',
        imei: browserInfo.imei || '',
        duid: browserInfo.duid || '',
      },
    ],
    {
      appId: '130900',
      logTag: '10006',
      eventID: eventID,
      module: '12009',
      imei: browserInfo.imei || '',
      duid: browserInfo.duid || '',
      buuid: buuid,
      ...(await getReportHeadInfo(browserInfo)),
    },
    true,
  );
}

// 相关搜索埋点事件
export async function relatedSearchReport(data, eventID) {
  const browserInfo = await BrowserBridgeHandler.getBrowserInfo();
  dcsReport.send(
    [
      {
        appId: '2007',
        logTag: '10006',
        imei: browserInfo.imei || '',
        duid: browserInfo.duid || '',
        buuid: buuid,
        logMap: JSON.stringify(data),
        eventID,
        module,
      },
    ],
    {
      appId: '2007',
      logTag: '10006',
      buuid: buuid,
      ...(await getReportHeadInfo(browserInfo)),
    },
    true,
  );
  obusReport.send(
    [
      {
        appId: '2007',
        logTag: '10006',
        imei: browserInfo.imei || '',
        duid: browserInfo.duid || '',
        buuid: buuid,
        logMap: JSON.stringify(data),
        eventID,
        module,
      },
    ],
    {
      appId: '2007',
      logTag: '10006',
      buuid: buuid,
      ...(await getReportHeadInfo(browserInfo)),
    },
    true,
  );
}

export const statH5 = {
  onClickRelatedNews,
  onRelatedNewsExposured,
  statVideoPlayingDuration,
  statPageLife,
};
